import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    header: {
        logoFilePath: "",
        adminName: ""
    },
    token: "",
    menuList: [],
    admin: {
        level: "",
        id: "",
    },
    isSuperAdmin: false
};
export const loginSlice = createSlice({
    name: "login",
    initialState: initialState,
    reducers: {
        changeLoginState: (state, action) => {
            state.header = action.payload.header;
            state.token = action.payload.token;
            state.menuList = action.payload.menuList;
            state.admin = action.payload.admin;
            state.isSuperAdmin = action.payload.isSuperAdmin;
        }
    }
})

export const { changeLoginState } = loginSlice.actions;
export default loginSlice.reducer;